import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeftIcon } from '../template/kartera/icons'
import KarteraThemeSwitch from '../template/kartera/KarteraThemeSwitch'

export const AUTH_ACCENT = '#4B44D8'

export const authFieldClass = (invalid: boolean) => (
    `h-[50px] w-full box-border rounded-xl bg-k-surface px-3.5 text-[15px] font-normal text-k-ink ${invalid ? 'border-2 border-k-danger' : 'border border-k-line-strong'}`
)

const BrandMark = ({ className = 'h-11 w-11 rounded-xl' }: { className?: string }) => (
    <img src="/brand/kartera365-icon.png" alt="" className={className} />
)

const BrandAside = () => (
    <aside aria-label="Kartera 365" className="relative flex min-h-[280px] flex-[1_1_440px] flex-col justify-between gap-8 overflow-hidden bg-[#121826] p-[clamp(28px,5vw,56px)] text-white">
        <svg aria-hidden="true" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid slice" className="absolute -bottom-[60px] -right-20 h-[520px] w-[520px] opacity-90">
            <polygon points="40,40 160,40 40,200" fill="#1FC8C1" opacity="0.85" />
            <polygon points="40,200 160,40 160,230" fill="#3E6BE6" opacity="0.85" />
            <polygon points="40,200 160,230 40,360" fill="#5B4BD8" opacity="0.85" />
            <polygon points="160,230 300,40 360,40 250,200" fill="#8B3FC9" opacity="0.8" />
            <polygon points="160,230 250,200 230,280" fill="#EC3B6C" opacity="0.85" />
            <polygon points="230,280 250,200 370,360 250,360" fill="#FF7A3D" opacity="0.85" />
            <polygon points="160,230 230,280 250,360 160,360" fill="#E8336D" opacity="0.7" />
        </svg>
        <span aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(90deg,#121826_35%,rgba(18,24,38,0.55)_70%,rgba(18,24,38,0.2))]" />
        <div className="relative flex items-center gap-3">
            <BrandMark />
            <span className="flex flex-col leading-[1.05]">
                <span className="text-[22px] font-extrabold tracking-[-0.02em]">Kartera</span>
                <span className="text-xs font-bold tracking-[0.32em] text-[#8C95A8]">365</span>
            </span>
        </div>
        <div className="relative flex max-w-[420px] flex-col gap-3.5">
            <h1 className="m-0 text-[clamp(30px,3.6vw,44px)] font-extrabold leading-[1.08] tracking-[-0.035em]">
                Tu cartera de seguros, en orden los 365 días.
            </h1>
            <p className="m-0 text-base leading-[1.55] text-[#C5CAD8]">Pólizas, cobranza y renovaciones de tus clientes en un solo lugar.</p>
        </div>
        <p className="relative m-0 text-xs text-[#8C95A8]">
            © {new Date().getFullYear()} Kartera 365 ·{' '}
            <Link to="/aviso-privacidad" className="font-semibold text-[#C5CAD8] no-underline hover:underline hover:underline-offset-[3px]">Aviso de privacidad</Link>
            {' · '}
            <Link to="/terminos-condiciones" className="font-semibold text-[#C5CAD8] no-underline hover:underline hover:underline-offset-[3px]">Términos</Link>
        </p>
    </aside>
)

export const BackToLogin = ({ onClick }: { onClick: () => void }) => (
    <button
        type="button"
        onClick={onClick}
        className="flex min-h-9 cursor-pointer items-center gap-1.5 self-start border-0 bg-transparent p-0 text-sm font-semibold text-k-muted"
    >
        <ChevronLeftIcon />
        Volver a iniciar sesión
    </button>
)

export interface AuthLayoutProps {
    children: React.ReactNode
    helpText?: string
}

const AuthLayout = ({ children, helpText = '¿Problemas para entrar?' }: AuthLayoutProps) => (
    <div className="k-root flex min-h-dvh flex-wrap items-stretch bg-k-bg font-kartera text-k-ink">
        <BrandAside />
        <main className="flex flex-[1_1_440px] flex-col px-[clamp(20px,4vw,48px)] pb-8 pt-5">
            <div className="flex justify-end">
                <KarteraThemeSwitch compact />
            </div>
            <div className="flex flex-1 items-center justify-center py-6">
                <div className="flex w-full max-w-[400px] flex-col gap-6">
                    {children}
                </div>
            </div>
            <p className="m-0 text-center text-[13px] text-k-muted">
                {helpText}{' '}
                <a href="mailto:info@dalala.mx" className="font-bold text-k-accent-ink">Contacta a soporte</a>
            </p>
        </main>
    </div>
)

export default AuthLayout
